var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',[_c('vs-col',{staticClass:"p-2",attrs:{"vs-lg":"12","vs-sm":"12"}},[_c('UserInfo',{attrs:{"teacherPersonalDetails":_vm.teacherPersonalDetails,"teacher_id":_vm.teacher_id},on:{"setAfterUpdate":_vm.setAfterUpdate}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }